module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFwAAAAsCAYAAADozd+ZAAABXElEQVR4Xu3b4RGCMAwF4McEOoojOIqO4QKuoU6iIziKI3g5UE4RbG2anOTxu1D57l1tw6UBL1OBxnQ2TgaCG4cgIvgSwM3Y+TldNHDBPgO4Ath6oEcDXwG4AFgAOHqgRwOXULuiRwR3RY8K7oYeGdwFPTq4OTrB272h2R8pwfvNuAk6wV9PP9XRCT48blZFJ/jn8301dIKPF1SqoBN8uoKljk7w7yVDVXSCfwdX3acTPA1cDZ3g6eAq6CXgewC7vN87u9HZHzEIXpaBE4BNziNKwHPmmctYwT10L5ONLfcRPD0KxdgEN8YmeBq4SrIfU3FJmUZXxWbCjbEJPg6unmwuKQ7YTPgQvVqymXAHbCa8R6+ebCbcAZsJbwtPRbWRtLNTPyrywcccO3LCXbCjgrthRwRfdz0+8u4/1bNz1+z38dHWcGmqkh4faarK+lJTCh15W8i2Qa30/MNz7lmaTi3a/yUKAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow-right.png
// module id = XRqo
// module chunks = 1